import styled from 'styled-components';

const EmailInputStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .EmailInput {
    &__label {
      color: #11111180;
      padding-bottom: 0.4rem;
      font-size: 1.2rem;
    }

    &__input {
      width: 100%;
      padding: 0 12px;
      font-size: 16px;
      line-height: 2.4;
      color: #111111;
      border: 0.1rem solid #d9d9d9;
      border-radius: 0.4rem;
      outline: none;
      font-family: inherit;

      &:hover {
        border-color: var(--palette-primary, #4611cf);
      }

      &:focus {
        border-color: var(--palette-primary, #4611cf);
        outline: 0;
        box-shadow: 0 0 0 0.2rem #1890ff33;
      }
    }

    &__errorMessage {
      display: inline-block;
      padding-top: 4px;
      font-size: 12px;
      color: #eb5757;
    }
  }
`;

export { EmailInputStyled as default };
//# sourceMappingURL=bundle.esm2.js.map
